import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae7a8ec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar3-week" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-hourglass" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-stopwatch" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightning" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "LOADING", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-hammer" })
], -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "effort-comment"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-hourglass" }, null, -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "effort-comment"
}
const _hoisted_25 = {
  key: 0,
  class: "prospects"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-stopwatch" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-hourglass" })
], -1))
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square-dotted" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightning" }, null, -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightning" }, null, -1))
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square-dotted" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 0 }

import { Timespending } from '@/app.context/workspace/Event'
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel'
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel'
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel'
import { computed, onMounted, reactive, ref, watch } from 'vue'

import { emitDefinition } from '../../tickets/_spec/ticket.controller.ui'
import { Sunrise, TimeSegment } from '@/logic/_infra/time'
import { mefforts_ext } from './todo.controller.basic'
import { timingOptions } from '@/components/Workspaces/todos/_spec/todo.controller.basic'
import { useAppContext } from '@/app/_tech'

import sys from '@/sys'
import { Guid } from '@/lib'
import * as array from '@/lib/array.lib'
import { ExactMeffortRmodel, Meffort, SimpleMeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import TimesegmentComponent from '@/components/Workspaces/_infra/time/TimesegmentComponent.vue'
import TimelengthComponent from '@/components/Workspaces/_infra/time/TimelengthComponent.vue'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech'
import { roundToClosestQuarterHour } from '@/lib/date'
import { dateOrNull } from '@/io/dto/infrastructure.dto.ns'
import MeetingParticipantsPicker from '@/components/Workspaces/_spec/MeetingParticipantsPicker.vue'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel'
import { IMeetingDto } from '@/io/dto/workspaces/eventw.dto'
import { IMeffortDto } from '@/io/dto/workspaces/persons/effort.dto'
import { OccupationtRef } from '@/logic/workspaces/tickets/_def'

//src\components\Workspaces\todos\_spec\todo.controller.basic.ts

const SHIFT_STEP = 15


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketTiming',
  props: {
    ticket: {},
    todo: {},
    category: {},
    efforts: {},
    participants: { type: Boolean }
  },
  emits: emitDefinition,
  setup(__props: any, { emit: __emit }) {

const participants = ref<InstanceType<typeof MeetingParticipantsPicker> | null>(null)

const context = useAppContext()

const props = __props

const emit = __emit

const state:
    {
        loading: boolean,
        date: Date,
        extended: boolean, //showing calendar for navigation of backdating edits
        efforts: SunriseReportRmodel | null,
        submenu:
        {
            timespendings: boolean,
            mefforts: boolean
        },
        meffort:
        {
            simple: boolean,
            exact: boolean
        },
        timespending: boolean

    } = reactive({
        loading: false,
        extended: false,
        efforts: props.efforts ?? null,
        submenu: { timespendings: false, mefforts: false },
        meffort: { simple: false, exact: false },
        timespending: false,
        date: props.efforts?.timestamp ?? new Date()
    })

const options = computed(() => {

    if (state.efforts != null) {




        const result = timingOptions(context.timepoint.value, state.efforts, props.ticket ?? null, props.todo ?? null, props.category ?? null)

        return result
    }

    else return null

})

onMounted(() => {

    setupState()
})

function onEnhancedEditing() {

    state.extended = !state.extended

    state.date = props.efforts?.timestamp.cloneAndAddDays(-1) ?? new Date()

    if (state.extended) {


        state.date = props.efforts?.timestamp.cloneAndAddDays(-1) ?? new Date()
    }
    else {
        state.efforts = props.efforts ?? null

        state.date = new Date(props.efforts?.timestamp ?? new Date())
    }

}

// function onExtendedEditingClose() {

//     state.extended = false

//     state.date = props.efforts?.timestamp.cloneAndAddDays(-1) ?? new Date()
// }

const dating = computed(() => {

    if (props.efforts != undefined && state.efforts != props.efforts) {

        const s = Sunrise.DateAsSunrise(state.date) //'s' for state

        const n = Sunrise.DateAsSunrise(props.efforts.timestamp)

        const ss = s.date().getTime()
        const nn = n.date().getTime()

        return {
            back: ss < nn,
            future: nn < ss,
            now: nn == ss
        }
    }
    else return {
        back: false,
        future: false,
        now: false
    }


})

function setupState() {

    const o = options.value

    if (o != null) {

        if (o.prospects_aux.mefforts.length > 0) {

            state.meffort.exact = true
            //state.meffort.simple = true
            //state.timespending = false
        }
        else state.timespending = o.prospects_aux.timespendings.length > 0
    }
    else {
        state.meffort.simple = false
        state.meffort.exact = false
        state.timespending = false
    }
}


const state_ui = computed(state_controls)

function state_controls(): { meffort: { exact: boolean, simple: boolean }, timespending: boolean } {



    const result = { meffort: { simple: false, exact: false }, timespending: false }

    const o = options.value


    if (o != null) {

        result.meffort.simple = o.prospects_aux.mefforts.length > 0
        result.meffort.exact = o.prospects_aux.mefforts.length > 0
        result.timespending = o.prospects_aux.timespendings.length > 0
    }
    else {
        result.meffort.simple = false
        result.meffort.exact = false
        result.timespending = false
    }

    if (state.meffort.simple) result.meffort.simple = false
    if (state.meffort.exact) result.meffort.exact = false
    if (state.timespending) result.timespending = false


    return result
}


function resetState() {

    state.meffort.exact = false
    state.meffort.simple = false
    state.timespending = false
}


const h =
{
    meffort_simple() {

        resetState();
        state.meffort.simple = true

    },

    meffort_exact() {

        resetState();
        state.meffort.exact = true

    },

    timespending() {

        resetState();
        state.timespending = true
    }
}

function incrementDelta_minutes(timesegment: TimeSegment, d: Direction, e: SegmentEnd) {




    let y = timesegment.timepoint

    if (e == 'E') y = timesegment.end()

    let newPoint = roundToClosestQuarterHour(y, d === 'B' ? 'back' : 'forward') // now.cloneAndAddMilliseconds(-1* DEFAULT_TIMEFRAME) 

    const delta_mins = Math.floor(Math.abs(newPoint.getTime() - y.getTime()) / 60000)

    return delta_mins
}

function createMeffort(timesegment?: TimeSegment, minutes?: number, d?: Direction, e?: SegmentEnd) {

    try {

        if (timesegment != undefined) {

            if (d != undefined) {

                if (e == undefined) e = "E"

                const delta_mins = incrementDelta_minutes(timesegment, d, e)

                timesegment.shiftEdge(e, d, delta_mins, SHIFT_STEP)
            }
        }

        if (timesegment != undefined) return createMeffort_Basic(timesegment.timespan_min_floor, timesegment.timepoint)

        else if (minutes != undefined) return createMeffort_Basic(minutes, null)

        else throw new Error("At lease 1 argument should be provided");

    } catch (error) {

        sys.exception(error)

    }
}


function createMeffort_Basic(minutes: number, timepoint: Date | null) {

    const p = user_person()

    const efforts = state.efforts // p?.efforts ?? null

    if (p != null && efforts != null) {

        let args: Meffort

        if (timepoint != null) {

            const m = new ExactMeffortRmodel()

            args = m

            m.objects.setTicketOrTodoRef(props)

            //TodoRmodel.ticketOrTodoRef_WriteTo(props, m)

            m.segment = new TimeSegment(timepoint, minutes * 60000)

            efforts.mefforts.exact.push(m)
        }
        else {
            const m = new SimpleMeffort()

            args = m

            m.objects.setTicketOrTodoRef(props)

            //TodoRmodel.ticketOrTodoRef_WriteTo(props, m)

            m.minutes = minutes

            efforts.mefforts.simple.push(m)
        }



        AuxOptions_WriteTo(p, args.objects)



        efforts.summary.refresh()

        context.storages.workspace!.personMeffortCreate(args.mid, p.workspace!.wid, p.nid, efforts.period.timepoint, minutes, timepoint, args.dto())
    }
    else sys.warn('workspace is null')
}


function AuxOptions_WriteTo(p: PersonRmodel, args: OccupationtRef) {

    const prmt = context.prompt;

    if (prmt != undefined) {

        args.title = prmt()
    }

    const participants_control = participants.value

    if (participants_control != null) {

        const buffer = participants_control.participants()

        buffer.groups.forEach(g => args.addGroup(g, p.workspace))
        buffer.persons.forEach(x => args.addPerson(x, p.workspace))
    }

    //PersonRmodel.ParticipantsSetup(args, p.workspace, args.persons, args.groups, context.service)
}



function deleteMeffort(m: Meffort) {

    const mid: Guid = m.mid

    const p = user_person()

    const efforts = state.efforts //p?.efforts ?? null

    if (p != null && efforts != null) {

        array.remove(efforts.mefforts.simple, m)

        array.remove(efforts.mefforts.exact, m)

        efforts.summary.refresh()

        context.storages.workspace!.personMeffortDelete(mid, p.workspace.wid, p.nid)
    }
    else sys.warn('Empty person')
}

const workspace = computed(() => user_person()?.workspace ?? null)

function user_person() {

    const workspace = props.ticket?.workspace ?? props.todo?.ticket?.workspace ?? props.efforts?.person.workspace ?? null

    const p = workspace?.user_person ?? null

    return p
}

function updateMeffort_simple(meffort: SimpleMeffort, direction: Direction) {

    let x = meffort.minutes

    if (direction == 'F') x += SHIFT_STEP
    if (direction == 'B') x -= SHIFT_STEP

    if (x < 0) x = 0

    updateMeffort(meffort.mid, x, null)
}


//e.stopPropagation is not a function



function updateMeffort_exact(meffort: ExactMeffortRmodel, direction: Direction, edge: SegmentEnd) {


    let x = meffort.segment.clone()

    const delta_mins = incrementDelta_minutes(x, direction, edge)

    x.shiftEdge(edge, direction, delta_mins, SHIFT_STEP)

    updateMeffort_segment(meffort.mid, x)
}

function updateMeffort_segment(mid: Guid, segment: TimeSegment) {

    updateMeffort(mid, segment.timespan_min_floor, segment.timepoint)
}



function updateMeffort(mid: Guid, minutes: number, timepoint: Date | null) {

    const p = user_person()

    const efforts = state.efforts //p?.efforts ?? null

    if (p != null && efforts != null) {



        if (timepoint == null) {

            const meffort_simple = array.single(efforts.mefforts.simple, x => x.mid === mid)

            meffort_simple.minutes = minutes
        }
        else {
            const meffort_exact = array.single(efforts.mefforts.exact, x => x.mid == mid)

            meffort_exact.segment = new TimeSegment(timepoint, minutes * 60000)
        }


        //efforts.mefforts.simple.filter(x=>x.``)

        efforts.summary.refresh()

        context.storages.workspace!.personMeffortUpdate(mid, p.workspace.wid, p.nid, minutes, timepoint)
    }
    else sys.warn('Empty person')
}

/**IN MINUTES */
function createTimespending(timesegment: TimeSegment, d?: Direction, e?: SegmentEnd) {

    const p = user_person()

    const efforts = state.efforts // p?.efforts ?? null



    if (p != null && efforts != null) {

        //const tid = ref.mid

        const ts = new Timespending()

        const tid = ts.tid

        ts.segment = timesegment.clone()

        if (d != undefined) {

            if (e == undefined) e = "E"

            const delta = incrementDelta_minutes(timesegment, d, e)

            ts.segment.shiftEdge(e, d, delta, SHIFT_STEP)
        }

        ts.objects.setTicketOrTodoRef(props)

        //TodoRmodel.ticketOrTodoRef_WriteTo(props, ts)

        AuxOptions_WriteTo(p, ts.objects)

        efforts.timespendings.push(ts)

        efforts.summary.refresh()

        context.storages.workspace!.personTimespendingCreate(tid, p.workspace.wid, p.nid, ts)
    }
    else sys.warn('Empty person')
}

function deleteTimespending(ts: Timespending) {

    const tid: Guid = ts.tid

    const p = user_person()

    const efforts = state.efforts //p?.efforts ?? null

    if (p != null && efforts != null) {

        let index = efforts.timespendings.indexOf(ts)

        if (index >= 0) {

            array.remove(efforts.timespendings, ts)
        }

        index = efforts.timespendings_Current.indexOf(ts)

        if (index >= 0) array.remove(efforts.timespendings_Current, ts)

        efforts.summary.refresh()

        context.storages.workspace!.personTimespendingDelete(tid, p.workspace.wid, p.nid)
    }
    else sys.warn('Empty person')

}

//{uid | null, TimeSegment} -> timespending
//{uid | null, TimeSegment} -> meffort

//const context = useAppContext()

// const test = computed(() => {

//     return context.timepoint.toISOString()
// })



//context.triggers.onTick()







const mefforts = computed(() => {

    return mefforts_ext(state.efforts, props)
})

function updateCandidateTimesegmetn(ts: TimeSegment, newEnd: number) {

    return new TimeSegment(ts.timepoint, newEnd - ts.timepoint.getTime())
}

const updateCandidate = computed(() => {

    const m = mefforts.value

    const u = (options.value?.prospects_aux.mefforts.length ?? 0) > 0 ? options.value!.prospects_aux.mefforts[0].segment : null  //'u' fro 'update'

    if (m != null && u != null) {

        const c = m.exact.filter(x => x.segment.end().getTime() == u.timepoint.getTime())

        if (c.length > 0) return { meffort: c[0], newEnd: u.end().getTime() }
        //
    }

    return null
})

watch(() => state.date, () => {

    //if (context.cursor.person != null) setupInternal(context.cursor.person)

    if (props.efforts?.person == null) return


    if (!state.extended) return; //avoid request when we just close popup and system reset 'sate.date' to default

    const p = props.efforts.person

    const d = state.date;

    const sunrise = Sunrise.DateAsSunrise(d)

    state.loading = true

    //read events, tasks, operations and endeavours on $date
    context.service.personEfforts(p.nid, sunrise).then(efforts => {

        state.efforts = SunriseReportRmodel.Instance(p, efforts.period, efforts, context)

        state.loading = false
    })
        .catch(sys.exception)
})


return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (mefforts.value != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (options.value != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: "clickable",
                onClick: _withModifiers(onEnhancedEditing, ["stop"])
              }, _hoisted_4),
              (state_ui.value.meffort.simple)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "clickable",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (h.meffort_simple && h.meffort_simple(...args)), ["stop"]))
                  }, _hoisted_6))
                : _createCommentVNode("", true),
              (state_ui.value.meffort.exact)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "clickable",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (h.meffort_exact && h.meffort_exact(...args)), ["stop"]))
                  }, _hoisted_8))
                : _createCommentVNode("", true),
              (state_ui.value.timespending)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: "clickable",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (h.timespending && h.timespending(...args)), ["stop"]))
                  }, _hoisted_10))
                : _createCommentVNode("", true),
              (updateCandidate.value != null)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 3,
                    class: "clickable tag-update",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (updateMeffort_segment(updateCandidate.value.meffort.mid, new (_unref(TimeSegment))(updateCandidate.value.meffort.segment.timepoint, (updateCandidate.value.newEnd - updateCandidate.value.meffort.segment.timepoint.getTime())))), ["stop"]))
                  }, "UPDATE"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (state.extended)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(state.date.toDateString()), 1))
          : _createCommentVNode("", true),
        (state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({ today: dating.value.now, backdate: dating.value.back, futuredate: dating.value.future })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mefforts.value.exact, (m) => {
            return (_openBlock(), _createElementBlock("div", {
              key: m.mid.toString()
            }, [
              _hoisted_15,
              _createVNode(TimesegmentComponent, {
                segment: m.segment,
                offset: _ctx.efforts?.offset ?? null,
                onClick: function (d, e) { updateMeffort_exact(m, d, e,) },
                "stop-propagation": true
              }, null, 8, ["segment", "offset", "onClick"]),
              _createElementVNode("span", {
                class: "clickable",
                onClick: _withModifiers(($event: any) => (deleteMeffort(m)), ["stop"])
              }, _hoisted_18, 8, _hoisted_16),
              _createElementVNode("span", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.objects.groups, (g) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: g.uid.toString()
                  }, "@@" + _toDisplayString(g.name), 1))
                }), 128)),
                _createTextVNode(),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.objects.persons, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: p.nid.toString()
                  }, "@" + _toDisplayString(p.name), 1))
                }), 128)),
                _createTextVNode(),
                ((m.name ?? '').length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(m.name), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mefforts.value.simple, (m) => {
            return (_openBlock(), _createElementBlock("div", {
              key: m.mid.toString()
            }, [
              _hoisted_20,
              _createVNode(TimelengthComponent, {
                minutes: m.minutes,
                onClick: (d) => updateMeffort_simple(m, d),
                "stop-propagation": true
              }, null, 8, ["minutes", "onClick"]),
              _createElementVNode("span", {
                onClick: _withModifiers(($event: any) => (deleteMeffort(m)), ["stop"])
              }, _hoisted_23, 8, _hoisted_21),
              _createElementVNode("span", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.objects.groups, (g) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: g.uid.toString()
                  }, "@@" + _toDisplayString(g.name), 1))
                }), 128)),
                _createTextVNode(),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.objects.persons, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: p.nid.toString()
                  }, "@" + _toDisplayString(p.name), 1))
                }), 128)),
                _createTextVNode(),
                ((m.name ?? '').length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(m.name), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (options.value != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value.prospects_aux.mefforts, (p, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (i == 0 || state.submenu.mefforts)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (state.meffort.exact)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ alert: p.overwrite, pending: !p.overwrite })
                                }, _hoisted_27, 2),
                                _createVNode(TimesegmentComponent, {
                                  segment: p.segment,
                                  offset: _ctx.efforts?.offset ?? null,
                                  onClick: (d, e) => createMeffort(p.segment, undefined, d, e),
                                  "stop-propagation": true
                                }, null, 8, ["segment", "offset", "onClick"]),
                                _createElementVNode("span", {
                                  class: "clickable ui-accent",
                                  onClick: _withModifiers(($event: any) => (createMeffort(p.segment)), ["stop"])
                                }, _hoisted_30, 8, _hoisted_28),
                                ((options.value?.prospects_aux.mefforts.length ?? 0) > 1 && i == 0)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "clickable",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (state.submenu.mefforts = !state.submenu.mefforts), ["stop"]))
                                    }, _hoisted_32))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (state.meffort.simple)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_33,
                                _createVNode(TimelengthComponent, {
                                  minutes: p.segment.timespan_min_floor,
                                  onClick: (d) => createMeffort(undefined, p.segment.timespan_min_floor, d),
                                  "stop-propagation": true
                                }, null, 8, ["minutes", "onClick"]),
                                _createElementVNode("span", {
                                  class: "clickable ui-accent",
                                  onClick: _withModifiers(($event: any) => (createMeffort(undefined, p.segment.timespan_min_floor)), ["stop"])
                                }, _hoisted_36, 8, _hoisted_34)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (options.value == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " No new meffort available "))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mefforts.value.timespendings, (ts) => {
            return (_openBlock(), _createElementBlock("div", {
              key: ts.tid.toString()
            }, [
              _hoisted_38,
              _createVNode(TimesegmentComponent, {
                segment: ts.segment,
                offset: _ctx.efforts?.offset ?? null
              }, null, 8, ["segment", "offset"]),
              _createElementVNode("span", {
                onClick: _withModifiers(($event: any) => (deleteTimespending(ts)), ["stop"])
              }, _hoisted_41, 8, _hoisted_39)
            ]))
          }), 128)),
          (options.value != null && state.timespending && options.value.prospects_aux.timespendings.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value.prospects_aux.timespendings, (ts, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    (i == 0 || state.submenu.timespendings)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_42,
                          _createVNode(TimesegmentComponent, {
                            class: "pending",
                            segment: ts,
                            offset: _ctx.efforts?.offset ?? null,
                            onClick: (d, e) => createTimespending(ts, d, e),
                            "stop-propagation": true
                          }, null, 8, ["segment", "offset", "onClick"]),
                          _createElementVNode("span", {
                            class: "clickable ui-accent",
                            onClick: _withModifiers(($event: any) => (createTimespending(ts)), ["stop"])
                          }, _hoisted_45, 8, _hoisted_43),
                          ((options.value?.prospects_aux.timespendings.length ?? 0) > 1 && i == 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "clickable",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (state.submenu.mefforts = !state.submenu.mefforts), ["stop"]))
                              }, _hoisted_47))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (options.value == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, " No new timespending available "))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 2),
        (state.extended && state.efforts != null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
              class: "calendar"
            }, [
              _createVNode(_component_v_date_picker, {
                modelValue: state.date,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.date) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.$props.participants ?? false) && workspace.value != null)
          ? (_openBlock(), _createBlock(MeetingParticipantsPicker, {
              key: 4,
              workspace: workspace.value,
              ref_key: "participants",
              ref: participants
            }, null, 8, ["workspace"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})